var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect, useRef, useContext, useCallback } from 'react';
import Select from 'react-select';
import { AppContext } from '../index';
import { useNavigate } from 'react-router-dom';
var SaveInfo = function (_a) {
    var title = _a.title, setTitle = _a.setTitle, teams = _a.teams, teamValue = _a.teamValue, setTeam = _a.setTeam, saveClick = _a.saveClick, cancelClick = _a.cancelClick, callback = _a.callback;
    var t = useContext(AppContext).t;
    return (React.createElement("div", { className: "titleWrapper" },
        callback.current && (React.createElement("div", { className: "sharing" }, t('map_editor.save_to_share'))),
        React.createElement("div", { className: "titleLabel" }, t('map_editor.map_title')),
        React.createElement("input", { type: "text", placeholder: t('map_editor.map_title'), value: title, onChange: function (e) { return setTitle(e.target.value); } }),
        teams.length > 1 && (React.createElement(Select, { className: "teamDropDown", options: teams, value: teamValue, placeholder: t('map_editor.no_team'), onChange: function (selectedOption) { return setTeam(selectedOption); } })),
        React.createElement("div", { className: "button save", onMouseUp: saveClick }, t('map_editor.save')),
        React.createElement("div", { className: "button cancel", onMouseUp: cancelClick }, t('map_editor.cancel_save'))));
};
var MapEditor = function (_a) {
    var onInitialized = _a.onInitialized, invalidateMapList = _a.invalidateMapList, showSaveInfo = _a.showSaveInfo, setShowSaveInfo = _a.setShowSaveInfo, share = _a.share, saveCallbackRef = _a.saveCallbackRef;
    var _b = useContext(AppContext), checkAndUpdate = _b.checkAndUpdate, waitingView = _b.waitingView, setWaitingView = _b.setWaitingView, selectedEditMap = _b.selectedEditMap, setSelectedEditMap = _b.setSelectedEditMap, theme = _b.theme, t = _b.t, i18n = _b.i18n, driveState = _b.driveState, setDriveState = _b.setDriveState, isLoggedIn = _b.isLoggedIn;
    var mapContainerRef = useRef(null);
    var scribbleMapRef = useRef(null);
    var _c = __read(useState(false), 2), mapLoaded = _c[0], setMapLoaded = _c[1];
    var _d = __read(useState(''), 2), title = _d[0], setTitle = _d[1];
    var _e = __read(useState(null), 2), teamValue = _e[0], setTeam = _e[1];
    var _f = __read(useState([]), 2), teams = _f[0], setTeams = _f[1];
    var navigate = useNavigate();
    var _g = __read(useState(window.innerWidth), 2), innerWidth = _g[0], setInnerWidth = _g[1];
    var _h = __read(useState(window.innerHeight - 36), 2), innerHeight = _h[0], setInnerHeight = _h[1];
    useEffect(function () {
        if (window.sm) {
            window.sm.settings.setLanguage(i18n.language);
        }
    }, [i18n.language]);
    useEffect(function () {
        var handleResize = function () {
            setInnerWidth(window.innerWidth);
            setInnerHeight(window.innerHeight - 36);
            if (window.sm) {
                window.sm.settings.resize();
            }
        };
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    var loadWaitingView = useCallback(function () {
        if (waitingView) {
            window.sm.map.setCenter([waitingView.latitude, waitingView.longitude]);
            window.sm.map.setZoom(waitingView.zoom);
            window.sm.map.setType(waitingView.mapType);
            setWaitingView(null);
        }
    }, [waitingView, setWaitingView]);
    useEffect(function () {
        if (scribbleMapRef.current) {
            scribbleMapRef.current.ui.setTheme(theme == "dark" ? "dark2021" : "light2021");
        }
    }, [theme]);
    useEffect(function () {
        onInitialized();
        //load the scribble map script from https://scribblemaps.com/api/js
        //wait for script to load before initializing the map
        var script = document.createElement('script');
        window.smapiloaded = function () {
            if (mapContainerRef.current && !scribbleMapRef.current) {
                var sm_1 = new ScribbleMap(mapContainerRef.current, {
                    tools: ["dragEditAdvanced", "drag", "eraser", "slash", "scribbleSnap", "line", "polygon", "singleMarker", "labelMulti", "photo"],
                    gpsControl: true,
                    undoControl: true,
                    isEditor: true,
                    isLite: true,
                    // Google gates its VECTOR renderer behind a WebGL probe that passes
                    // failIfMajorPerformanceCaveat, which fails on plenty of real devices - and RASTER
                    // cannot rotate, so supportsBearing() comes back false and the compass never appears.
                    // forceGL takes the GL path anyway (see GProxyMap.enableGoogleSoftwareWebGL), which is
                    // what makes map rotation available on lite at all.
                    forceGL: true,
                    startCenter: [39.8283, -98.5795],
                    /* startZoom: 3, */
                    streetViewControl: true,
                    theme: theme == "dark" ? "dark2021" : "light2021",
                    fractionalZoom: false,
                    useBaseDistanceMatrix: true,
                    controlMode: { 'mapType': scribblemaps.ControlModes.SMALL }
                });
                window['showSaveMap'] = function () {
                    saveMapCall();
                };
                sm_1.ui.setTheme(theme == "dark" ? "dark2021" : "light2021");
                sm_1.ui.setMapTypeControlMode(scribblemaps.ControlModes.SMALL);
                sm_1.ui.setSearchControlMode(scribblemaps.ControlModes.SMALL);
                sm_1.addListener("ready", function () {
                    window.FeatureTracking.update();
                    window.useGoogle = true;
                    window.createLayers(sm_1);
                    window.sm.settings.setLanguage(i18n.language);
                    sm_1.settings.resize();
                    //prevent data loss
                    sm_1.settings.enableChangesHalt();
                    if (!selectedEditMap) {
                        if (navigator.geolocation) {
                            navigator.geolocation.getCurrentPosition(function (position) {
                                setTimeout(function () {
                                    if (position.coords.latitude != null && !isNaN(position.coords.latitude)) {
                                        sm_1.view.setZoom(13);
                                        sm_1.view.setCenter([position.coords.latitude, position.coords.longitude]);
                                    }
                                }, 0);
                            });
                        }
                    }
                    /* setTimeout(() => {
                      sm.ui.showNotice("Best Experience on PC/Tablet", { time: 10000 });
                    }, 150); */
                    sm_1.ui.setModalElement(document.getElementById("map-container"));
                    sm_1.ui.disableFooter();
                    sm_1.ui.styleControl(scribblemaps.ControlType.FILL_COLOR, { left: "0", width: "34px" });
                    sm_1.ui.styleControl(scribblemaps.ControlType.LINE_COLOR, { left: "32px", width: "32px" });
                    sm_1.ui.styleControl(scribblemaps.ControlType.SEARCH, { display: "block", left: "0", top: "0", zIndex: 14 });
                    sm_1.map.setType("hybrid");
                    if (selectedEditMap) {
                        sm_1.map.loadById(selectedEditMap.mapCode, function () {
                            loadWaitingView();
                        });
                    }
                    else {
                        sm_1.map.createNewMap(function () {
                            loadWaitingView();
                        });
                    }
                    setMapLoaded(true);
                    if (window.appSettings)
                        window.sm.settings.updateCredentials(window.appSettings);
                });
                window.sm = sm_1;
                scribbleMapRef.current = sm_1;
            }
        };
        //allow script to set window variables
        script.async = true;
        script.src = window.jsAPI + "?async=true&callback=smapiloaded&d=" + window.jsAPIDate;
        document.body.appendChild(script);
        /* return () => {
           document.body.removeChild(script);
         }; */
    }, []);
    // Initialize ScribbleMap only once when the component mounts
    // Load the selected map when `selectedMap` changes
    useEffect(function () {
        var sm = window.sm;
        if (sm && selectedEditMap) {
            if (sm.map.getWorkingInfo().id !== selectedEditMap.mapCode) {
                sm.map.loadById(selectedEditMap.mapCode);
            }
        }
    }, [selectedEditMap]);
    useEffect(function () {
        var sm = window.sm;
        var deleteCookie = function (name, path) {
            if (path === void 0) { path = '/'; }
            // Build the cookie string to expire
            var cookieString = "".concat(encodeURIComponent(name), "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=").concat(path, ";");
            document.cookie = cookieString;
        };
        if (driveState && sm && isLoggedIn) {
            sm.ui.importDriveFiles(driveState);
            deleteCookie("sm_drive_state");
            setDriveState(null);
        }
    }, [driveState, mapLoaded, isLoggedIn]);
    var saveMapCall = function (callback) {
        if (sm) {
            if (sm.map.isFresh()) {
                //short month day, year HH:MM:SS - lite Map;
                var defaultTitle = new Date().toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                }) + " - Lite";
                setTitle(defaultTitle);
                var teams_1 = sm.settings.getTeams();
                //only map team where team.hasSeat == true
                var teamOptions = teams_1.filter(function (team) {
                    return team.hasSeat;
                }).map(function (team) {
                    return { value: team.teamCode, label: team.name };
                });
                teamOptions.unshift({ value: '', label: t('map_editor.no_team') });
                setShowSaveInfo(true);
                saveCallbackRef.current = callback;
                setTeams(teamOptions);
            }
            else {
                if (callback) {
                    callback();
                }
                sm.map.saveCurrent(function () {
                    //navigate(`/editor/${sm.map.getWorkingInfo().id}`, {replace: true});
                    if (!callback) {
                        checkAndUpdate();
                    }
                });
            }
        }
    };
    return (React.createElement("div", { style: { height: '100%', width: '100%', position: "absolute", left: 0, top: 0 } },
        showSaveInfo && (React.createElement("div", { className: "saveInfo" },
            React.createElement(SaveInfo, { callback: saveCallbackRef, title: title, setTitle: setTitle, teams: teams, teamValue: teamValue, setTeam: setTeam, cancelClick: function () {
                    setShowSaveInfo(false);
                }, saveClick: function () {
                    if (sm) {
                        if (!navigator.onLine) {
                            sm.ui.showAlert(t('ui_offline_msg'), [t('ui_ok')]);
                            return;
                        }
                        var workingInfo_1 = sm.map.getWorkingInfo();
                        var saveData_1 = {
                            id: workingInfo_1.id,
                            password: '',
                            teamCode: teamValue ? teamValue.value : '',
                            title: title,
                            description: sm.map.getWorkingInfo().description || t('map_editor.saved_lite'),
                            listed: false,
                            secure: false
                        };
                        setShowSaveInfo(false);
                        //because of gesture handling, we need to call navigator share immediately while it is saving
                        if (saveCallbackRef.current) {
                            saveCallbackRef.current();
                            saveCallbackRef.current = null;
                        }
                        setTimeout(function () {
                            sm.map.save(saveData_1, function () {
                                invalidateMapList({
                                    mapCode: workingInfo_1.id,
                                    teamCode: teamValue ? teamValue.value : '',
                                    teamName: teamValue ? teamValue.label : '',
                                    created: new Date().toISOString(),
                                    lastModified: new Date().toISOString(),
                                    title: title,
                                    description: saveData_1.description,
                                }, saveCallbackRef.current != null);
                                checkAndUpdate();
                            });
                        }, 0);
                    }
                } }))),
        React.createElement("div", { className: "editorNav" },
            React.createElement("div", { className: 'navItem help', onMouseUp: function () {
                    navigate('/help');
                } }, t('map_editor.help')),
            React.createElement("div", { className: "navItem", onMouseUp: function () {
                    if (sm) {
                        window.FeatureTracking.trackEditorEvent('new');
                        if (sm.map.hasChanges()) {
                            sm.ui.showAlert("<strong>" + t('map_editor.unsaved_changes') + "</strong><br>" + t('map_editor.create_new'), [t('ui_confirm'), t('ui_cancel')], [function () {
                                    setSelectedEditMap(null);
                                    //navigate('/editor', {replace: true});
                                    sm.map.createNewMap();
                                }]);
                        }
                        else {
                            setSelectedEditMap(null);
                            //navigate('/editor', {replace: true});
                            sm.map.createNewMap();
                        }
                    }
                } }, t('map_editor.new_map')),
            React.createElement("div", { className: "navItem", onMouseUp: function () {
                    window.FeatureTracking.trackEditorEvent('save');
                    saveMapCall();
                } }, t('map_editor.save')),
            React.createElement("div", { className: 'navItem share', onMouseUp: function () {
                    window.FeatureTracking.trackEditorEvent('share');
                    if (sm.map.isFresh() || window.sm.ui.isHalted()) {
                        saveMapCall(function () {
                            share({
                                title: sm.map.getWorkingInfo().title,
                                description: sm.map.getWorkingInfo().description,
                                mapCode: sm.map.getWorkingInfo().id
                            });
                        });
                    }
                    else {
                        share({
                            title: sm.map.getWorkingInfo().title,
                            description: sm.map.getWorkingInfo().description,
                            mapCode: sm.map.getWorkingInfo().id
                        });
                    }
                } }, t('map_editor.share')),
            React.createElement("div", { className: 'settings', onMouseUp: function () {
                    sm.ui.showPanel(scribblemaps.PanelType.SETTINGS);
                } })),
        React.createElement("div", { id: "map-container", ref: mapContainerRef, style: { top: '36px', bottom: '0', height: innerHeight + 'px', width: innerWidth + 'px', position: "absolute", left: 0 } }),
        !mapLoaded && (React.createElement("div", { className: "mapLoader" }))));
};
export default MapEditor;
